import button from './buttonLanding';

export default button;
